// custom typefaces
import "typeface-montserrat";
import "typeface-merriweather";
//global styles
import "./src/styles/global.css";
